import { render, staticRenderFns } from "./Deleteworks.vue?vue&type=template&id=48ed38b6&scoped=true"
import script from "./Deleteworks.vue?vue&type=script&lang=js"
export * from "./Deleteworks.vue?vue&type=script&lang=js"
import style0 from "./Deleteworks.vue?vue&type=style&index=0&id=48ed38b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed38b6",
  null
  
)

export default component.exports